import { http } from "@/http";

// Dashboard operativo (DEF-ADM-028). Todo de lectura.
//
// La ciudad va como query param y no en X-City-Id: la pantalla tiene su propio
// selector con una opción "Todas" que el header no puede expresar. Mismo
// criterio que Confirmaciones (DEF-ADM-024). cityId null u omitido = todas.
const conCiudad = (cityId, extra = {}) => {
  const params = { ...extra };
  if (cityId) params.city_id = cityId;
  return { params };
};

export default {
  today(cityId) {
    return http.get("/api/v1/dashboard/today", conCiudad(cityId));
  },
  month(cityId, year, month) {
    return http.get("/api/v1/dashboard/month", conCiudad(cityId, { year, month }));
  },
  ventasMes(cityId, year, month) {
    return http.get("/api/v1/dashboard/ventas-mes", conCiudad(cityId, { year, month }));
  },
  upcoming(cityId) {
    return http.get("/api/v1/dashboard/upcoming", conCiudad(cityId));
  },
  drivers(cityId) {
    return http.get("/api/v1/dashboard/drivers", conCiudad(cityId));
  },
  alerts(cityId) {
    return http.get("/api/v1/dashboard/alerts", conCiudad(cityId));
  },
};
